module.exports = __webpack_public_path__ + "img/comment_6.d91b4196.png";